import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calculator } from 'lucide-react';

const FloatingCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Don't show on contact page or calculator page
  if (location.pathname === '/contact' || location.pathname === '/septic-calculator') {
    return null;
  }

  const handleClick = () => {
    navigate('/contact');
  };

  return (
    <button
      data-testid="floating-estimate-button"
      onClick={handleClick}
      className="gh-floating-cta gh-button"
      style={{
        backgroundColor: 'var(--primary-orange)',
        boxShadow: '0 10px 25px rgba(255, 107, 26, 0.4)'
      }}
    >
      <Calculator size={20} />
      <span>Get Estimate Now</span>
    </button>
  );
};

export default FloatingCTA;
